import React from 'react';
import './Events.css';

const Events = () => {
  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Events Management</h1>
      </div>

      {/* Simple Coming Soon Message */}
      <div className="text-center py-5 my-5">
        <div className="coming-soon-simple">
          <i className="fas fa-tools fa-3x text-warning mb-3"></i>
          <h2 className="text-primary mb-3">Coming Soon</h2>
          <p className="text-muted mb-4">
            The Events feature is currently under development and will be available soon.
          </p>
          
          {/* Fixed centered badge */}
          <div className="test" style={{width: 'fit-content'}}>
            <i className="fas fa-clock me-2"></i>
            Estimated Launch: Soon
          </div>
        </div>
      </div>
    </div>
  );
};

export default Events;